import { render, staticRenderFns } from "./stockList.vue?vue&type=template&id=52d80902"
import script from "./stockList.vue?vue&type=script&lang=js"
export * from "./stockList.vue?vue&type=script&lang=js"
import style0 from "./stockList.vue?vue&type=style&index=0&id=52d80902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports